// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"3114b2fa","453":"cb92c59e","667":"06e99611"}[chunkId] + ".chunk.js";
};